
import { useContext } from 'react';
import { ResourcesContext } from '../contexts/ResourcesContext';
import { getDefaultImageForType } from '@/utils/resourceUtils';

export const useResources = () => {
  const context = useContext(ResourcesContext);
  
  if (context === undefined) {
    throw new Error('useResources must be used within a ResourcesProvider');
  }

  // Get resource by ID with imageUrl handling
  const enhancedGetResourceById = (id: string) => {
    const resource = context.getResourceById(id);
    if (resource && !resource.imageUrl) {
      // If imageUrl is missing, check if we can find it in defaultResources
      const defaultResource = context.getDefaultResource(id);
      if (defaultResource && defaultResource.imageUrl) {
        console.log('Restoring missing imageUrl for resource:', id);
        return { ...resource, imageUrl: defaultResource.imageUrl };
      }
      // If still no image, use a default based on resource type
      return { 
        ...resource, 
        imageUrl: getDefaultImageForType(resource.type) 
      };
    }
    return resource;
  };
  
  // Return a simpler version of the context
  return {
    ...context,
    getResourceById: enhancedGetResourceById
  };
};
